export const mutations = {
  userInformationLoaded(state, { userInformation }) {
    state.userInformation = {
      ...state.userInformation,
      ...userInformation,
      isLoaded: true,
    };
  },
};
